import { Button } from 'components/Button';
import styled from 'styled-components';

export const ActiveModalOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75);
  inset: 0;
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: #242424 !important;

  padding: 1.5rem 2rem;

  border-radius: 4px;

  max-width: 25vw;

  @media (max-width: 1440px) {
    max-width: 35vw;
  }
`;

export const Body = styled.div`
  h2 {
    text-align: center;
  }

  p {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    margin: 2.5rem 0rem;
    text-align: center;
    color: var(--grey-100);
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;
`;

export const AlertButton = styled(Button)``;
